import { Badge } from "@/ui";
import { useT } from "@/app";
import { flagVisual } from "../lib";

/**
 * FlagBadge — the clinical interpretation chip for a CompteRenduLigne `drapeau`. Always COLOR + GLYPH
 * + TEXT (clinical Badge tones inject the mandated shape glyph; never color alone — daltonisme + médico-légal).
 */
export function FlagBadge({ drapeau }: { drapeau: string | null }) {
  const { t } = useT();
  const v = flagVisual(drapeau);
  return <Badge tone={v.tone}>{t(v.labelKey)}</Badge>;
}
